import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const TabTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.isActive ? colors.primary : colors.transparent};
  border-radius: 19px;
  height: 38px;
  transition: background-color 0.5s;
`;

export default TabTitleWrapper;
